<template>
    <Popup :priority="100"
           :class="['step-' + step]"
           size="small dark"
           ref="innerPopup"
           v-slot="popup"
    >
        <slot v-bind="popup" :step="step" :advance-step="advanceStep" :accept-url="acceptUrl" />
    </Popup>
</template>

<script>
    import Popup from "../components/util/Popup.vue";

    export default {
        name: 'CamPopup',

        data() {
            return {
                step: 1,
                zone: undefined,
                performer: undefined,
            };
        },

        // This API is resolved dynamically on page load
        inject: ['camsApi'],

        computed: {
            acceptUrl() {
                return this.camsApi.makeAcceptUrl({
                    zone: this.zone,
                    performer: this.performer,
                });
            }
        },

        methods: {
            advanceStep(increment = 1) {
                this.step += increment;
            },

            show() {
                this.step = 1;
                this.$refs.innerPopup.show();
            },

            hide() {
                this.$refs.innerPopup.hide();
            },

            setParams(params) {
                this.zone = params.zone;
                this.performer = params.performer;
            },
        }
    }
</script>

